module.exports = __webpack_public_path__ + "img/sld_spd.32ca6697.svg";